import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ddbe4cd4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "label-wrapper" }
const _hoisted_2 = { class: "label" }
const _hoisted_3 = {
  key: 0,
  class: "required"
}
const _hoisted_4 = { key: 0 }

import { v4 as uuid } from 'uuid';
import Mark from '../mark/Mark.vue';

interface Props {
  label: string;
  required?: boolean;
  tooltip?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Label',
  props: {
    label: null,
    required: { type: Boolean },
    tooltip: null
  },
  setup(__props: any) {



const id = `uuid_${uuid()}`;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("label", { for: id }, [
          _renderSlot(_ctx.$slots, "label", {}, () => [
            _createTextVNode(_toDisplayString(__props.label), 1)
          ])
        ]),
        (__props.required)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*"))
          : _createCommentVNode("", true)
      ]),
      (__props.tooltip)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(Mark, {
              small: "",
              "tooltip-message": __props.tooltip,
              icon: "question",
              color: "primary"
            }, null, 8, ["tooltip-message"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", null, [
      _renderSlot(_ctx.$slots, "default", { id: id })
    ])
  ]))
}
}

})